var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-dark iq-ptb-10 header-top-bar"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-auto mr-auto"},[_vm._t("leftLinks")],2),_vm._v(" "),_c('div',{staticClass:"col-auto"},[_c('div',{staticClass:"social-bar"},[_vm._t("rightLinks")],2)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }